module.exports = __webpack_public_path__ + "static/img/frack02.d31a7ab8.png";